/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { UserBubble } from '@neo4j-ndl/react/ai';

const Component = () => {
  return (
    <UserBubble
      avatarProps={{
        name: 'KM',
        type: 'letters',
      }}
    >
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed in rutrum
      massa, ut congue nisi. Curabitur pulvinar odio id eros ornare dictum.
      Aliquam faucibus dui ligula, ac gravida enim mattis at. Proin pretium
      massa a risus eleifend consectetur. Fusce auctor maximus tellus sed
      lobortis. Nulla congue leo posuere ante accumsan, vel maximus justo
      cursus. Sed cursus varius ante at scelerisque. Fusce non venenatis diam.
      Nam sed dolor ultricies, varius sem sed, vulputate felis. Ut facilisis
      efficitur sem, et laoreet neque. Fusce congue vulputate magna. Mauris
      euismod egestas imperdiet. Sed mollis venenatis nunc eget laoreet.
    </UserBubble>
  );
};

export default Component;
